// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgScreenShare24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M22 5C22 3.89543 21.1046 3 20 3H4C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H8.25V20C8.25 20.9665 9.0335 21.75 10 21.75H14C14.9665 21.75 15.75 20.9665 15.75 20V18H20C21.1046 18 22 17.1046 22 16V5ZM9.75 20V18H14.25V20C14.25 20.1381 14.1381 20.25 14 20.25H10C9.86193 20.25 9.75 20.1381 9.75 20ZM20 4.5H4C3.72386 4.5 3.5 4.72386 3.5 5V16C3.5 16.2761 3.72386 16.5 4 16.5H20C20.2761 16.5 20.5 16.2761 20.5 16V5C20.5 4.72386 20.2761 4.5 20 4.5ZM11.9306 6.25316L11.8637 6.26242L11.7613 6.28881L11.6748 6.32393L11.58 6.3785L11.5417 6.40627L11.4697 6.46967L8.46967 9.46967C8.17678 9.76256 8.17678 10.2374 8.46967 10.5303L8.55379 10.6029C8.8474 10.8208 9.26406 10.7966 9.53033 10.5303L11.25 8.811V14C11.25 14.4142 11.5858 14.75 12 14.75L12.1018 14.7432C12.4678 14.6935 12.75 14.3797 12.75 14V8.811L14.4697 10.5303C14.7359 10.7966 15.1526 10.8208 15.4462 10.6029L15.5303 10.5303C15.8232 10.2374 15.8232 9.76256 15.5303 9.46967L12.5303 6.46967L12.4516 6.40116L12.4203 6.37876L12.369 6.34686L12.2981 6.3116L12.2393 6.28898L12.1714 6.26973L12.0774 6.25398L12.0174 6.2502L11.9306 6.25316Z"
				/>
			</Svg>
		);
	}
);
SvgScreenShare24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgScreenShare24;
